import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWindow"><Path d="M3.5 9.5V3.5H20.5V9.5M3.5 9.5V20.5H20.5V9.5M3.5 9.5H20.5M9.5 6.5H17.5M7 6.5C7 6.77614 6.77614 7 6.5 7C6.22386 7 6 6.77614 6 6.5C6 6.22386 6.22386 6 6.5 6C6.77614 6 7 6.22386 7 6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWindow;
